import { useQuery } from '@tanstack/react-query';
import { httpClient, ROOT_URL } from '../../App';

export const useMetadataCurrencyToken = (networkId?: number) => {
  const { data } = useQuery(
    ['/api/v1/asset-config-groups/crypto', networkId],
    async () => {
      const url = networkId
        ? `${ROOT_URL}/api/v1/asset-config-groups/crypto?_networkId=${networkId}`
        : `${ROOT_URL}/api/v1/asset-config-groups/crypto`;
      const response = await httpClient.get(url);
      return response.data;
    },
    {
      enabled: true,
    }
  );

  const metadataCurrencyToken = (data?.data || []).map((item: any) => ({
    value: item.id,
    label: item.symbol || item.name,
  }));

  return { metadataCurrencyToken, dataCurrencyToken: data?.data || [] };
};

